export default __webpack_public_path__ + "static/media/Aayan-Ahmad-Resume.02c85aa2.pdf";